/**
 * Featured Tiles — front-end behaviour.
 *
 * Turns each block's tile track into a Swiper slider. The Swiper library is
 * loaded once per page as a shared dependency (see EnqueueStylesAndScripts and
 * BlockFeaturedTiles), so this file only wires up the instances and reads
 * `window.Swiper`. Navigation arrows are rendered by PHP only when there are
 * more than three tiles; on mobile they are hidden with CSS and the track is
 * swipeable. `watchOverflow` disables sliding when every tile already fits.
 */

const BLOCK_SELECTOR = '.b-featured-tiles';
const SLIDER_SELECTOR = '.b-featured-tiles__slider';

/**
 * Initialise a single slider instance.
 *
 * @param {HTMLElement} block The block root element.
 */
const initSlider = ( block ) => {

	const slider = block.querySelector( SLIDER_SELECTOR );

	if ( ! slider || slider.dataset.swiperReady === 'true' ) {

		return;

	}

	const prevEl = block.querySelector( '.b-featured-tiles__nav-button--prev' );
	const nextEl = block.querySelector( '.b-featured-tiles__nav-button--next' );

	// eslint-disable-next-line no-new
	new window.Swiper( slider, {
		slidesPerView: 1.25,
		spaceBetween: 22, //1.38rem
		watchOverflow: true,
		allowTouchMove: true,
		simulateTouch: true,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
			releaseOnEdges: true,
		},
		grabCursor: true,
		threshold: 8,
		a11y: {
			enabled: true,
			prevSlideMessage: 'Previous tile',
			nextSlideMessage: 'Next tile',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		navigation: ( prevEl && nextEl ) ? { prevEl, nextEl } : false,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
		},
	} );

	slider.dataset.swiperReady = 'true';

};

/**
 * Boot all sliders on the page.
 */
const init = () => {

	if ( typeof window.Swiper !== 'function' ) {

		return;

	}

	document.querySelectorAll( BLOCK_SELECTOR ).forEach( initSlider );

};

if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', init );

} else {

	init();

}
